export default __webpack_public_path__ + "static/media/char_frame_bg_large.996b3162.png";